import { HttpParams } from '@angular/common/http';

export function buildGridParams(
  filter: string,
  orderBy: string,
  sort: string,
  page: number,
  pageSize: number,
  filterBy: string,
): HttpParams {
  return new HttpParams()
    .set('filter', filter)
    .set('orderBy', orderBy)
    .set('sort', sort)
    .set('page', page.toString())
    .set('pageSize', pageSize.toString())
    .set('filterBy', filterBy);
}
